import React from 'react';
import { MedicationCourse, MedicationExpiry, MedicationStatus } from '../Contracts/MedicationModels';
import { medicationAboutToExpireIcon, medicationExpired, medicationStopped, primary } from '../Styles/Colours';
import { PillIcon } from './Icons';
import { MedicationCardMode } from './MedicationCard';
export var MedicationCourseIcon = function (props) {
    var courseBackgroundColour = function () {
        if (props.status === MedicationStatus.Stopped)
            return medicationStopped;
        if (props.expiry === MedicationExpiry.Expired)
            return medicationExpired;
        if (props.expiry === MedicationExpiry.AboutToExpire)
            return medicationAboutToExpireIcon;
        return primary;
    };
    var iconSize = props.mode === MedicationCardMode.Condensed ? '32' : '40';
    switch (props.course) {
        case MedicationCourse.Regular:
            return React.createElement(PillIcon, { size: iconSize });
        case MedicationCourse.ShortCourse:
            return React.createElement(PillIcon, { size: iconSize });
        case MedicationCourse.AsRequired:
            return React.createElement(PillIcon, { size: iconSize });
        case MedicationCourse.Daa:
            return React.createElement(PillIcon, { size: iconSize });
        case MedicationCourse.None:
            return React.createElement(PillIcon, { size: iconSize });
    }
};
